import { initVoting } from './voting';

if (window.votings && Array.isArray(window.votings) && window.votings.length) {
    window.votings.forEach(voting => initVoting(voting));
}
